import CryptoJS from 'crypto-js';
import {blobToBase64, getVideoRatio, initDevice} from "../../../../utils";
import {documentValidator, validateSignature} from "../../../../services/documentValidator";
import {EVENT_TRACER} from "../../../../constants";
import {onReportEvent} from "../../../cardCapture/utils";

export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const cv = window.cv;
const MAX_FPS_DETECTION_VALUE = 500 // Optimizado: Reducir carga de requestAnimationFrame
export class Detector {
    static croppedImage = true
    static hasResponseToValidation = false

    constructor({stream, device, modelPath, croppedImage, urlService, isFront, documentType, processId, onStatusChange}) {
        this.probabilityThreshold = 50;
        this.counterSuccessfulResults = 0;
        this.MAX_FPS_DETECTION = MAX_FPS_DETECTION_VALUE;
        this.rendering = {
            now: 0,
            elapsed: 0,
            then: 0,
        };
        this.MAX_NUMBER_FACES = 1;
        this.MAX_ANGLE_TURN_HEAD = 30;
        this.MIN_FACE_SIZE_FOR_MOBILE = 224;
        this.MIN_FACE_SIZE_FOR_DESKTOP = 350;
        this.MIN_OCCUPIED_SPACE_FOR_DESKTOP = 15;
        this.MIN_OCCUPIED_SPACE_FOR_MOBILE = 15;
        this.X_OFFSET_FROM_FRAME = 15;
        this.Y_OFFSET_FROM_FRAME = 5;
        this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
        this.videoRatio = 1;
        this.showDetectedFace = false;
        this.headTurnCounter = 0;
        this.counterSuccessfulHeadTurns = 0;
        this.stream = stream;
        this.isMobile = device.isMobile;
        this.modelPath = modelPath;
        this.croppedImage = croppedImage
        this.urlService = urlService
        this.documentType = documentType
        this.isFront = isFront
        this.processId = processId
        this.onStatusChange = onStatusChange

        this.ws = null
        this.clientId = null
        this.isProcessing = false
        this.lastStatus = null
        this.autoCapture = false
        this.autoCaptureInterval = null
        this.captureIntervalMs = 500 // Optimizado: 2 capturas por segundo para mejor detección liveness

        this.mediaRecorder = null
        this.recordedChunks = []
        this.recordingInterval = null
        this.isRecording = false
        this.chunksSent = 0
        this.bytesSent = 0
        this.frameCount = 0
        this.videoInterval = null
        this.streamingMode = "video"
    }
    setProbabilityThreshold(val) {
        this.probabilityThreshold = val;
    }
    static getInstance(detectorProperties) {
        if (!Detector.instance) {
            Detector.instance = new Detector(detectorProperties);
        }
        return Detector.instance;
    }
    updateHtmlElements(videoElement) {
        this.videoElement = videoElement;
    }
    static async initDetector(modelPath) {

        if (!isMobile()) {
            await this.loadingModels(modelPath);
        }

    }
    static async loadingModels(modelPath) {
        if (!this.modelsLoaded()) {

        }
    }
    static modelsLoaded() {
        return false
    }
    static async warmingUpModels() {
        // const image = new Image();
        // image.src = base64Photo;
        // await this.detectAllFaces(image);
    }

    static async generateHash(blobImage, processId) {
        return new Promise(async (resolve, reject) => {
            try {
                const arrayBuffer = await blobImage.blob.arrayBuffer();

                if (!arrayBuffer || arrayBuffer.byteLength === 0) {
                    throw new Error('Image arrayBuffer is empty');
                }

                console.log('Image ArrayBuffer Length:', arrayBuffer.byteLength);

                const uint8Array = new Uint8Array(arrayBuffer);

                const processIdBytes = new TextEncoder().encode(processId);

                const combinedData = new Uint8Array(processIdBytes.length + uint8Array.length);
                combinedData.set(processIdBytes, 0);
                combinedData.set(uint8Array, processIdBytes.length);

                const wordArray = CryptoJS.lib.WordArray.create(combinedData);


                const hash = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Base64);
                resolve({
                    hash,
                    preparedFile: blobImage.blob,
                });
            } catch (e) {
                reject(e)
            }
        })
    }

    static async prepareImageForUpload(blobImage, processId) {
        return new Promise(async (resolve, reject) => {
            try {
                const {hash, preparedFile} = await this.generateHash(blobImage, processId)

                const signatureResponse = await fetch('https://api-dev.ado-tech.com/api/key/generate-signature', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ hash, durationMinutes: 30, processId })
                });
                if (!signatureResponse.ok) {
                    const errorText = await signatureResponse.text();
                    throw new Error(`Failed to get signature: ${errorText}`);
                }
                const { signature, expiresAt } = await signatureResponse.json();
                console.log('Received Signature Response:', { signature, expiresAt });
                if (!signature) {
                    throw new Error('Signature is empty or invalid');
                }

                resolve({ preparedFile, hash, signature, expiresAt, processId });
            } catch (e) {
                reject(e)
            }
        })
    }

    static async resizeBase64(base64, width, height, quality, changeQuality = true) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                if (changeQuality) {
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                }

                canvas.toBlob(
                    (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve({
                                blob,
                                base64: reader.result
                            });
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    },
                    'image/jpeg',
                    changeQuality ? quality : 1
                );
            };
            img.onerror = reject;
            img.src = base64;
        });
    }
    static async detectAllFaces(videoSrc, croppedImage, urlService, documentType, isFront, processId) {
        if (this.hasResponseToValidation) {
            return
        }
        this.hasResponseToValidation = true
        let result = {
            isCard: false,
            image: '',
            documentName: '',
            documentMatch: false,
            status: 'no_detected'
        }
        try {
            onReportEvent(EVENT_TRACER.SERVICE.InitDetection, "Iniciando detección").catch();
            const width = videoSrc.videoWidth;
            const height = videoSrc.videoHeight;

            const originalCanvas = document.createElement('canvas');
            originalCanvas.width = width;
            originalCanvas.height = height;

            const contextOriginal = originalCanvas.getContext('2d');
            contextOriginal.drawImage(videoSrc, 0, 0, originalCanvas.width, originalCanvas.height);

            const originalImage = originalCanvas.toDataURL('image/jpeg');
            onReportEvent(EVENT_TRACER.SERVICE.CreateBase64Image, "Iniciando proceso de creación de base64").catch();
            const blobImage = await this.resizeBase64(originalImage, width, height, 1);
            onReportEvent(EVENT_TRACER.SERVICE.Base64ImageCreated, "Base64 de la imagen creada").catch();

            if (processId && processId.length > 0) {
                onReportEvent(EVENT_TRACER.SERVICE.SignImage, "Iniciando proceso de firmado de imagen").catch();
                const {preparedFile, hash, signature, expiresAt} = await this.prepareImageForUpload(blobImage, processId)
                onReportEvent(EVENT_TRACER.SERVICE.ImageSigned, "Finalizo proceso de firmado de imagen").catch();

                onReportEvent(EVENT_TRACER.SERVICE.InitValidateSignature, "Iniciando proceso de validación de firma de imagen").catch();
                const responseSignature = await validateSignature({
                    preparedFile,
                    signature,
                    hash,
                    expiresAt,
                    processId
                });

                onReportEvent(EVENT_TRACER.SERVICE.EndValidateSignature, "Finalizó proceso de validación de firma de imagen").catch();

                if (responseSignature.status !== 200 || responseSignature.data !== 'Valida Sign') {
                    onReportEvent(EVENT_TRACER.SERVICE.FailedValidateSignature, "La firma de la imagen no es valida").catch();
                    this.hasResponseToValidation = false
                    return result
                }
            }

            onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidate, "Enviando imagen al backend").catch();
            const response = await documentValidator({
                base64Data: blobImage.blob,
                urlService,
                isFront,
                documentType,
                processId,
            })
            onReportEvent(EVENT_TRACER.SERVICE.SendingImageToValidateFinish, `Respuesta del backend (${response.data.status || 'no_detected'})`).catch();

            this.hasResponseToValidation = false
            result.isCard = response.data.quality
            result.image = blobImage.base64;
            result.documentMatch = response.data.documentTypeMatch
            result.status = response.data.status || 'no_detected'

            if (this.instance && this.instance.stream) {
                this.instance.stream.returnStatus(result.status);
            }

            if (response.data.quality) {
                result.documentName = response?.data?.result?.documentName;
                result.status = 'detected';
            } else {
                result.documentName = "";
                result.status = 'no_detected';
            }
            return result;
        }
        catch (e) {
            result.status = 'error';
            if (this.instance && this.instance.stream) {
                this.instance.stream.returnStatus('error');
            }
            return result;
        }
    }
    async startDetector() {
        if (!this.videoElement)
            throw Error("Video element not found");
        if (this.videoElement.clientWidth === 0)
            throw Error("Video element too small");
        this.rendering.then = Date.now();
        this.counterSuccessfulResults = 0;
        this.updateForIos();
        this.videoRatio = getVideoRatio(this.videoElement);
        if (!Detector.modelsLoaded()) {
            await Detector.initDetector(this.modelPath);
        }
        this.requestAnimationFrame = requestAnimationFrame(() => this.detection());
    }
    stopDetector() {
        console.log("[WS-DETECTOR] 🛑 Deteniendo detector")
        
        if (this.requestAnimationFrame) {
            // @ts-ignore
            cancelAnimationFrame(this.requestAnimationFrame); // TODO
            this.requestAnimationFrame = undefined;
            console.log("[WS-DETECTOR] ✅ RequestAnimationFrame cancelado")
            
            if (this.innerCanvas) {
                this.innerCanvas.remove();
                console.log("[WS-DETECTOR] ✅ Canvas interno eliminado")
            }
            this.innerCanvas = undefined;
        }

        // Reset processing state
        console.log("[WS-DETECTOR] 🔄 Reseteando estado de procesamiento")
        this.isProcessing = false
        this.lastStatus = null
        this.clientId = null
        this.isRecording = false
        this.autoCapture = false

        if (this.mediaRecorder) {
            try {
                console.log("[WS-DETECTOR] 🎥 Deteniendo MediaRecorder, estado actual:", this.mediaRecorder.state)
                
                if (this.mediaRecorder.state === "recording") {
                    this.mediaRecorder.pause()
                    setTimeout(() => {
                        if (this.mediaRecorder && this.mediaRecorder.state === "paused") {
                            this.mediaRecorder.stop()
                            console.log("[WS-DETECTOR] ✅ MediaRecorder detenido desde estado recording")
                        }
                    }, 100)
                } else if (this.mediaRecorder.state === "paused") {
                    this.mediaRecorder.stop()
                    console.log("[WS-DETECTOR] ✅ MediaRecorder detenido desde estado paused")
                }
            } catch (error) {
                console.log(`[WS-DETECTOR] ⚠️ Error deteniendo MediaRecorder: ${error.message}`)
            } finally {
                this.mediaRecorder = null
                console.log("[WS-DETECTOR] ✅ MediaRecorder limpiado")
            }
        }

        if (this.recordingInterval) {
            clearInterval(this.recordingInterval)
            this.recordingInterval = null
            console.log("[WS-DETECTOR] ✅ Intervalo de grabación limpiado")
        }

        if (this.videoInterval) {
            clearInterval(this.videoInterval)
            this.videoInterval = null
            console.log("[WS-DETECTOR] ✅ Intervalo de video limpiado")
        }

        this.recordedChunks = []
        console.log("[WS-DETECTOR] ✅ Chunks grabados limpiados")

        // Stop auto capture and clear intervals
        this.stopAutoCapture()

        // Disconnect WebSocket connection
        this.disconnectWebSocket()

        // Reset processing state
        this.isProcessing = false
        this.lastStatus = null
        this.clientId = null

        console.log("[WS-DETECTOR] ✅ Detector completamente detenido y limpiado")
    }
    updateForIos() {
        const device = initDevice();
        if (device.isIos) {
            this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
            this.MAX_FPS_DETECTION = MAX_FPS_DETECTION_VALUE; // Mantener la misma velocidad en iOS
            Detector.isIos = true;
        }
    }
    async detection() {
        console.log("[WS-DETECTOR] 🚀 Iniciando detección con WebSocket")
        console.log("[WS-DETECTOR] 🔧 Configuración del detector:", {
            isMobile: this.isMobile,
            processId: this.processId,
            streamingMode: this.streamingMode,
            captureIntervalMs: this.captureIntervalMs
        })
        
        this.connectWebSocket()
        
        setTimeout(() => {
            console.log("[WS-DETECTOR] ⏰ Verificando estado de WebSocket después de 1 segundo")
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                console.log("[WS-DETECTOR] ✅ WebSocket está listo, iniciando captura")
                console.log("[WS-DETECTOR] 📹 Modo de streaming:", this.streamingMode)
                
                if (this.streamingMode === "video") {
                    console.log("[WS-DETECTOR] 🎥 Iniciando captura de video")
                    this.startVideoCapture()
                } else {
                    console.log("[WS-DETECTOR] 📸 Iniciando captura de imágenes")
                    this.startAutoCapture()
                }
            } else {
                console.log("[WS-DETECTOR] ⚠️ WebSocket no está listo:", {
                    exists: !!this.ws,
                    readyState: this.ws?.readyState,
                    expectedState: WebSocket.OPEN
                })
            }
        }, 1000)
    }
    startVideoCapture() {
        console.log("🎬 Iniciando captura de videos con chunks...")

        const captureVideo = () => {
            if (!this.autoCapture || this.isProcessing) {
                console.log("⏸️ Pausando captura - video en procesamiento")
                return
            }

            console.log(`🎥 Iniciando video chunk #${this.frameCount + 1}`)
            this.captureVideoChunks()
        }

        // Start first video immediately
        this.autoCapture = true
        captureVideo()

        // Set interval for subsequent videos
        this.videoInterval = setInterval(() => {
            if (this.autoCapture && !this.isProcessing) {
                captureVideo()
            } else if (!this.autoCapture) {
                clearInterval(this.videoInterval)
                this.videoInterval = null
            }
        }, 10000) // 10 seconds between videos (5s video + 5s pause)
    }

    captureVideoChunks() {
        if (!this.autoCapture || !this.videoElement) return

        // Check MediaRecorder availability
        if (typeof MediaRecorder === "undefined") {
            console.log("⚠️ MediaRecorder no disponible, usando fallback de imágenes")
            this.captureAndSend()
            return
        }

        // Get media stream from video element
        const stream = this.videoElement.srcObject
        if (!stream) {
            console.log("❌ No hay stream de video disponible")
            return
        }

        // Configure MediaRecorder options
        const options = {
            mimeType: "video/webm;codecs=vp8",
            videoBitsPerSecond: 1000000, // 1 Mbps
        }

        // Fallback if webm not supported
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            options.mimeType = "video/mp4"
        }

        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            console.log("⚠️ Formatos de video no soportados, usando fallback de imágenes")
            this.captureAndSend()
            return
        }

        console.log(`🎥 Configurando MediaRecorder con formato: ${options.mimeType}`)

        try {
            // Clean up previous MediaRecorder
            if (this.mediaRecorder) {
                try {
                    if (this.mediaRecorder.state === "recording") {
                        this.mediaRecorder.stop()
                    }
                } catch (error) {
                    console.log(`⚠️ Error limpiando MediaRecorder anterior: ${error.message}`)
                }
                this.mediaRecorder = null
            }

            // Create new MediaRecorder
            this.mediaRecorder = new MediaRecorder(stream, options)
            this.recordedChunks = []
            this.isRecording = false

            this.mediaRecorder.ondataavailable = (event) => {
                if (event.data && event.data.size > 0) {
                    this.recordedChunks.push(event.data)
                    console.log(`📦 Chunk recibido: ${this.formatBytes(event.data.size)}`)
                }
            }

            this.mediaRecorder.onstop = () => {
                console.log("🛑 MediaRecorder detenido, procesando fragmento...")
                this.isProcessing = true

                setTimeout(async () => {
                    if (this.recordedChunks.length > 0) {
                        const videoBlob = new Blob(this.recordedChunks, { type: options.mimeType })
                        console.log(
                            `📊 Fragmento creado: ${this.formatBytes(videoBlob.size)} con ${this.recordedChunks.length} chunks`,
                        )

                        // Verify blob is valid and has minimum size
                        if (videoBlob.size > 10000) {
                            // Minimum 10KB for valid video
                            this.sendVideoChunk(videoBlob)
                            console.log(`✅ Fragmento válido enviado: ${this.formatBytes(videoBlob.size)}`)
                        } else {
                            console.log(`⚠️ Fragmento muy pequeño, descartando: ${this.formatBytes(videoBlob.size)}`)
                        }

                        this.recordedChunks = []
                    } else {
                        console.log("⚠️ No hay chunks para procesar")
                    }

                    this.isProcessing = false
                    console.log(`✅ Video #${this.frameCount} procesado, listo para siguiente video`)

                    // Restart recording for next video
                    setTimeout(() => {
                        if (this.autoCapture && !this.isProcessing) {
                            console.log(`🔄 Reiniciando grabación para video #${this.frameCount + 1}...`)
                            this.captureVideoChunks()
                        }
                    }, 2000) // 2 second pause before next video
                }, 500)
            }

            this.mediaRecorder.onerror = (event) => {
                console.log(`❌ Error en MediaRecorder: ${event.error}`)
                this.recreateMediaRecorder()
            }

            // Start recording
            this.mediaRecorder.start(1000) // Generate chunks every 1 second
            this.isRecording = true
            console.log(`🎥 Grabación iniciada con formato: ${options.mimeType}`)

            // Create video fragments
            this.recordingInterval = setInterval(() => {
                if (this.mediaRecorder && this.mediaRecorder.state === "recording" && this.isRecording && this.autoCapture) {
                    try {
                        console.log(`🔄 Deteniendo fragmento ${this.frameCount + 1}...`)
                        this.mediaRecorder.stop()

                        setTimeout(() => {
                            if (this.autoCapture) {
                                try {
                                    this.mediaRecorder.start(1000)
                                    this.frameCount++
                                    console.log(`🔄 Fragmento ${this.frameCount} iniciado`)
                                } catch (startError) {
                                    console.log(`❌ Error al reiniciar MediaRecorder: ${startError.message}`)
                                    this.recreateMediaRecorder()
                                }
                            }
                        }, 1000)
                    } catch (stopError) {
                        console.log(`❌ Error al detener MediaRecorder: ${stopError.message}`)
                        this.recreateMediaRecorder()
                    }
                }
            }, 5000) // 5 second video fragments
        } catch (error) {
            console.log(`❌ Error configurando MediaRecorder: ${error.message}`)
            this.captureAndSend() // Fallback to image capture
        }
    }
    recreateMediaRecorder() {
        console.log("🔄 Recreando MediaRecorder...")

        if (this.mediaRecorder) {
            try {
                if (this.mediaRecorder.state === "recording") {
                    this.mediaRecorder.pause()
                    setTimeout(() => {
                        if (this.mediaRecorder && this.mediaRecorder.state === "paused") {
                            this.mediaRecorder.stop()
                        }
                    }, 100)
                } else if (this.mediaRecorder.state === "paused") {
                    this.mediaRecorder.stop()
                }
            } catch (error) {
                console.log(`⚠️ Error limpiando MediaRecorder anterior: ${error.message}`)
            } finally {
                this.mediaRecorder = null
            }
        }

        if (this.recordingInterval) {
            clearInterval(this.recordingInterval)
            this.recordingInterval = null
        }

        this.recordedChunks = []
    }
    async sendVideoChunk(videoBlob) {
        console.log("[WS-VIDEO] 📹 Preparando envío de chunk de video")
        console.log("[WS-VIDEO] 📊 Detalles del chunk:", {
            size: this.formatBytes(videoBlob.size),
            type: videoBlob.type,
            chunksSent: this.chunksSent,
            totalBytesSent: this.formatBytes(this.bytesSent)
        })
        
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            // Validate blob before sending
            if (!videoBlob || videoBlob.size === 0) {
                console.log("[WS-VIDEO] ❌ Blob inválido, no se puede enviar")
                return
            }

            if (videoBlob.size < 10000) {
                console.log(`[WS-VIDEO] ⚠️ Fragmento muy pequeño: ${this.formatBytes(videoBlob.size)}`)
                return
            }

            if (!videoBlob.type || !videoBlob.type.startsWith("video/")) {
                console.log(`[WS-VIDEO] ⚠️ Tipo MIME inválido: ${videoBlob.type}`)
                return
            }

            try {
                const base64 = await blobToBase64(videoBlob)
                console.log("[WS-VIDEO] 🔄 Video convertido a Base64, longitud:", base64.length)
                console.log("[WS-VIDEO] 📤 Enviando chunk de video al servidor")
                
                this.ws.send(videoBlob)
                this.chunksSent++
                this.bytesSent += videoBlob.size
                
                console.log(`[WS-VIDEO] ✅ Fragmento de video enviado: ${this.formatBytes(videoBlob.size)} (${videoBlob.type})`)
                console.log("[WS-VIDEO] 📊 Estadísticas de envío:", {
                    size: videoBlob.size,
                    type: videoBlob.type,
                    chunksSent: this.chunksSent,
                    totalBytes: this.formatBytes(this.bytesSent),
                })
            } catch (error) {
                console.log(`[WS-VIDEO] ❌ Error enviando fragmento: ${error.message}`)
            }
        } else {
            console.log("[WS-VIDEO] ❌ WebSocket no conectado, no se puede enviar fragmento:", {
                wsExists: !!this.ws,
                wsState: this.ws?.readyState,
                expectedState: WebSocket.OPEN
            })
        }
    }
    formatBytes(bytes) {
        if (bytes === 0) return "0 B"
        const k = 1024
        const sizes = ["B", "KB", "MB", "GB"]
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
    }
    captureAndSend() {
        console.log("[WS-CAPTURE] 📸 Iniciando captura y envío de imagen")
        
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
            console.log("[WS-CAPTURE] ❌ WebSocket no está conectado:", {
                wsExists: !!this.ws,
                wsState: this.ws?.readyState,
                expectedState: WebSocket.OPEN
            })
            return
        }

        // No enviar si ya está procesando para evitar saturar
        if (this.isProcessing) {
            console.log("[WS-CAPTURE] ⏸️ Saltando captura - procesamiento en curso")
            return
        }

        const imageData = this.captureImage()
        if (!imageData) {
            console.log("[WS-CAPTURE] ❌ No se pudo capturar imagen")
            return
        }

        // Usar configuración por defecto para validación
        const validationParams = {
            device: this.isMobile ? "mobile" : "desktop",
            score_threshold: this.probabilityThreshold / 100,
            use_model: true,
            return_original: false,
            isFront: this.isFront,
            Suprimir: false,
            use_fast_detection: true,
        }

        console.log("[WS-CAPTURE] 🔧 Parámetros de validación:", validationParams)

        // Enviar como JSON
        const message = {
            action: "validate_document",
            data: {
                image: imageData,
                ...validationParams,
            },
        }

        const messageStr = JSON.stringify(message)
        console.log(`[WS-CAPTURE] 📤 Enviando mensaje JSON - Tamaño: ${messageStr.length} chars`)
        console.log(`[WS-CAPTURE] 📋 Datos del mensaje:`, {
            action: message.action,
            dataKeys: Object.keys(message.data),
            imageLength: imageData.length,
            params: validationParams
        })
        
        this.ws.send(messageStr)
        this.isProcessing = true
        console.log("[WS-CAPTURE] ✅ Mensaje enviado, procesamiento en curso")
    }

    captureImage() {
        console.log("[WS-CAPTURE] 🎨 Capturando imagen del video")
        
        if (!this.videoElement) {
            console.log("[WS-CAPTURE] ❌ Video element no disponible")
            return null
        }

        try {
            const canvas = document.createElement("canvas")
            canvas.width = this.videoElement.videoWidth
            canvas.height = this.videoElement.videoHeight

            console.log(`[WS-CAPTURE] 📐 Dimensiones del canvas: ${canvas.width}x${canvas.height}`)

            const ctx = canvas.getContext("2d")
            ctx.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height)

            const imageData = canvas.toDataURL("image/jpeg", 0.8)
            console.log(`[WS-CAPTURE] ✅ Imagen capturada - Dimensiones: ${canvas.width}x${canvas.height}, Tamaño Base64: ${imageData.length} chars`)

            return imageData
        } catch (error) {
            console.log(`[WS-CAPTURE] ❌ Error capturando imagen: ${error.message}`)
            return null
        }
    }

    startAutoCapture() {
        if (this.autoCapture) {
            console.log("[WS-CAPTURE] ⚠️ Auto captura ya está activa")
            return
        }

        console.log(`[WS-CAPTURE] 🚀 Iniciando auto captura con intervalo de ${this.captureIntervalMs}ms`)
        this.autoCapture = true

        const doCapture = () => {
            if (!this.autoCapture) {
                console.log("[WS-CAPTURE] ⏹️ Auto captura desactivada, deteniendo")
                return
            }

            if (!this.isProcessing && this.ws && this.ws.readyState === WebSocket.OPEN) {
                console.log("[WS-CAPTURE] 📸 Capturando y enviando imagen")
                this.captureAndSend()
            } else if (this.isProcessing) {
                console.log(`[WS-CAPTURE] ⏸️ Saltando captura - procesamiento en curso (intervalo: ${this.captureIntervalMs}ms)`)
            } else {
                console.log("[WS-CAPTURE] ⚠️ WebSocket no disponible para captura:", {
                    wsExists: !!this.ws,
                    wsState: this.ws?.readyState,
                    isProcessing: this.isProcessing
                })
            }

            // Programar la siguiente captura
            this.autoCaptureInterval = setTimeout(doCapture, this.captureIntervalMs)
        }

        // Iniciar la primera captura
        console.log("[WS-CAPTURE] ▶️ Iniciando primera captura")
        doCapture()
    }

    stopAutoCapture() {
        console.log("[WS-CAPTURE] 🛑 Deteniendo auto captura")
        
        if (this.autoCaptureInterval) {
            clearTimeout(this.autoCaptureInterval)
            this.autoCaptureInterval = null
            console.log("[WS-CAPTURE] ✅ Intervalo de captura limpiado")
        }
        
        this.autoCapture = false
        console.log("[WS-CAPTURE] ✅ Auto captura detenida")
    }

    connectWebSocket() {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            console.log("[WS-CONNECTION] ✅ Ya hay una conexión WebSocket activa")
            return
        }

        const wsUrl = "wss://liveness-socket-dev.ado-tech.com/ws/video-stream?processId=af69d75a67bc434eb75fb8c52417a2f8&device=IOS"
        console.log(`[WS-CONNECTION] 🔌 Intentando conectar a WebSocket: ${wsUrl}`)

        this.ws = new WebSocket(wsUrl)

        this.ws.onopen = (event) => {
            console.log("[WS-CONNECTION] ✅ WebSocket conectado exitosamente")
            console.log("[WS-CONNECTION] 📊 Estado de conexión:", {
                readyState: this.ws.readyState,
                url: this.ws.url,
                protocol: this.ws.protocol,
                extensions: this.ws.extensions
            })
        }

        this.ws.onmessage = (event) => {
            console.log("[WS-MESSAGE] 📨 Mensaje recibido del servidor")
            console.log("[WS-MESSAGE] 📦 Datos recibidos (raw):", event.data)
            
            try {
                const message = JSON.parse(event.data)
                console.log('[WS-MESSAGE] 📋 Mensaje parseado (JSON):', message)
                
                switch (message.type) {
                    case 'STREAMING_STARTED':
                        console.log(`[WS-MESSAGE] 🎬 Streaming iniciado - ProcessId: ${message.processId}`)
                        break;

                    case 'CHUNK_RECEIVED':
                        console.log(`[WS-MESSAGE] 📦 Chunk recibido: ${message.chunkId} (${message.size} bytes)`)
                        break;

                    case 'VIDEO_PROCESSED':
                        console.log(`[WS-MESSAGE] ✅ Video procesado: ${message.chunkId}`)
                        console.log(`[WS-MESSAGE] 📊 Datos del video procesado:`, message)
                        break;

                    case 'REALTIME_ANALYSIS':
                        console.log(`[WS-MESSAGE] ⚡ Análisis en tiempo real: ${message.chunkId}`)
                        console.log(`[WS-MESSAGE] 📊 Datos del análisis:`, message)
                        break;

                    case 'PROCESSING_ERROR':
                        console.log(`[WS-MESSAGE] ❌ Error de procesamiento: ${message.error}`)
                        break;

                    case 'STREAMING_ENDED':
                        console.log(`[WS-MESSAGE] 🏁 Streaming finalizado - Total chunks: ${message.totalChunks}`)
                        break;

                    default:
                        console.log(`[WS-MESSAGE] ❓ Mensaje con tipo desconocido: ${message.type}`, message)
                }
            } catch (e) {
                console.log(`[WS-MESSAGE] 📝 Mensaje recibido (no JSON - texto plano): ${event.data}`)
            }
        }

        this.ws.onclose = (event) => {
            console.log(`[WS-CONNECTION] 🔒 WebSocket cerrado`)
            console.log(`[WS-CONNECTION] 📊 Detalles del cierre:`, {
                code: event.code,
                reason: event.reason || 'Sin razón especificada',
                wasClean: event.wasClean
            })
            this.ws = null
        }

        this.ws.onerror = (error) => {
            console.log(`[WS-CONNECTION] ❌ Error en WebSocket:`, error)
            console.log(`[WS-CONNECTION] 📊 Detalles del error:`, {
                message: error.message || "Error desconocido",
                type: error.type,
                target: error.target
            })
        }
    }

    disconnectWebSocket() {
        console.log("[WS-CONNECTION] 🔌 Desconectando WebSocket")
        
        if (this.ws) {
            console.log("[WS-CONNECTION] 📊 Estado del WebSocket antes de cerrar:", {
                readyState: this.ws.readyState,
                url: this.ws.url
            })
            
            this.ws.close()
            this.ws = null
            console.log("[WS-CONNECTION] ✅ WebSocket desconectado manualmente")
        } else {
            console.log("[WS-CONNECTION] ℹ️ No hay WebSocket para desconectar")
        }
    }


    autoCapturing(result) {
        this.stream.autoCapturing({
            ...result,
            status: result.status,
            quality: result.isCard
        });
        this.counterSuccessfulResults = 0;
    }
}
